//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('model', {
//        templateUrl: 'views/components/views/model/model.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'modelService', function ($stateParams, stateService, modelService) {
//            const vm = this;
//            let modelId = $stateParams.model_id;
            
//            vm.model = {
//                modelId: modelId,
//                edit: {},
//                lockedSave: false
//            };

//            async function loadEdit() {
//                vm.model.edit = (await modelService.getEdit({ model_id: modelId }))[0];
//            }
            
//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;
                
//                modelService.saveObj(vm.model.edit).then(function () {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, function () {
//                    vm.model.lockedSave = false;
//                });
//            };

//            vm.$onInit = function () {
//                loadEdit();
//            };
//        }]
//    });
//})();
